module.exports = __webpack_public_path__ + "img/ccm_pic_6.d9270d76.jpg";